export async function checkConnectionApi(accessToken: string) {
  const server = "/api/authorization/checkConnection";
  let headers = new Headers({
    Authorization: `Bearer ${accessToken}`,
    "content-type": "application/json",
  });
  try {
    const response = await fetch(server, {
      method: "GET",
      headers: headers,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
}
